import React from 'react'
import Footer from './Footer'
import Carousal from './Carousal'
import Section from '../pages/Section'
import Productcatogory from '../pages/Productcatogory'
import Visited from '../pages/Visited'

import Review from '../pages/Review'

const Layout = () => {
  return (
    <div>

      <Carousal />
      <Section />
      <Productcatogory />
      <Visited />
   
      <br/>
      <Review />

      <br />
      <Footer />
    </div>
  )
}

export default Layout